module.exports = __webpack_public_path__ + "img/klimatizace.beeb3da5.svg";